module.exports = __webpack_public_path__ + "static/media/sf-test-16.ce4b1e7d.mp3";